import { Modal, ConfigProvider } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
export const ConfirmTip = (props) => {
    ConfigProvider.config({
        prefixCls: 'grt'
    });

    Modal.confirm({
        icon: props.icon || <ExclamationCircleOutlined style={{ color: 'var(--grt-primary-6)' }}></ExclamationCircleOutlined>,
        title: <div style={{ paddingTop: '70px', height: '100px', display: 'block' }}>{props.title}</div> || <b>提示</b>,
        content: props.content || '',
        onOk: props.onOk || (() => {}),
        okText: props.okText || '确定',
        cancelText: props.cancelText || '取消',
        closable: props.closable || true,
        width: 500,
        style: { top: '25%' },
        ...props
    });
};
export const ErrorTip = (props) => {
    ConfigProvider.config({
        prefixCls: 'grt'
    });

    Modal.error({
        icon: <ExclamationCircleOutlined style={{ color: 'red' }}></ExclamationCircleOutlined>,
        title: props.title || '提示',
        content: props.content || '',
        okText: props.okText || '知道了',
        closable: props.closable || true,
        width: 500,
        style: { top: '25%' },
        ...props
    });
};
export default ConfirmTip;
